import { useEffect, useState } from 'react'

import { IntroContainer } from 'components/intro-container'
import {
  Gradient,
  TitleContainer,
  Title,
  Subtitle,
} from 'components/intro-container/styled'
import backgroundL from './images/Background_L.webp'
import backgroundM from './images/Background_M.webp'
import backgroundS from './images/Background_S.webp'
import houseL from './images/House_L.webp'
import houseM from './images/House_M.webp'
import houseS from './images/House_S.webp'
import hand1L from './images/Hand1_L.webp'
import hand1M from './images/Hand1_M.webp'
import hand1S from './images/Hand1_S.webp'
import hand2L from './images/Hand2_L.webp'
import hand2M from './images/Hand2_M.webp'
import hand2S from './images/Hand2_S.webp'
import shadow1L from './images/Shadow1_L.webp'
import shadow1M from './images/Shadow1_M.webp'
import shadow1S from './images/Shadow1_S.webp'
import shadow2L from './images/Shadow2_L.webp'
import shadow2M from './images/Shadow2_M.webp'
import shadow2S from './images/Shadow2_S.webp'
import {
  AnimationContainer,
  AllElements,
  Background,
  House,
  Shadow1,
  Shadow2,
  Hand1,
  Hand2,
} from './styled'
import { useAppContext } from 'context/app-context'

export const Animation = () => {
  const { setLoading, isPageVisible } = useAppContext()
  const [loadedImages, setLoadedImages] = useState(0)

  const onLoadImages = (e: React.SyntheticEvent<HTMLImageElement>) => {
    setLoadedImages((loadedImages) => loadedImages + 1)
  }

  const startAnimation = () => {}

  useEffect(() => {
    if (loadedImages === 6) {
      setLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadedImages])

  useEffect(() => {
    if (isPageVisible) {
      startAnimation()
    }
  }, [isPageVisible])

  return (
    <IntroContainer>
      <AnimationContainer>
        {/*
            <img className="celek" src={celek_L} />
            <img className="celek_M" src={celek_M} />
            <img className="celek_S" src={celek_S} />
            */}
        <AllElements $ani={isPageVisible}>
          <picture>
            <source
              srcSet={backgroundS}
              media="(max-width: 520px)"
              type="image/webp"
            />
            <source
              srcSet={backgroundM}
              media="(max-width: 1024px)"
              type="image/webp"
            />
            <Background
              alt="background"
              src={backgroundL}
              onLoad={onLoadImages}
            />
          </picture>
          <picture>
            <source
              srcSet={houseS}
              media="(max-width: 520px)"
              type="image/webp"
            />
            <source
              srcSet={houseM}
              media="(max-width: 1024px)"
              type="image/webp"
            />
            <House
              alt="house"
              $ani={isPageVisible}
              src={houseL}
              onLoad={onLoadImages}
            />
          </picture>
          <picture>
            <source
              srcSet={shadow1S}
              media="(max-width: 520px)"
              type="image/webp"
            />
            <source
              srcSet={shadow1M}
              media="(max-width: 1024px)"
              type="image/webp"
            />
            <Shadow1
              $ani={isPageVisible}
              alt="shadow1"
              src={shadow1L}
              onLoad={onLoadImages}
            />
          </picture>
          <picture>
            <source
              srcSet={shadow2S}
              media="(max-width: 520px)"
              type="image/webp"
            />
            <source
              srcSet={shadow2M}
              media="(max-width: 1024px)"
              type="image/webp"
            />
            <Shadow2
              $ani={isPageVisible}
              alt="shadow2"
              src={shadow2L}
              onLoad={onLoadImages}
            />
          </picture>
          <picture>
            <source
              srcSet={hand1S}
              media="(max-width: 520px)"
              type="image/webp"
            />
            <source
              srcSet={hand1M}
              media="(max-width: 1024px)"
              type="image/webp"
            />
            <Hand1
              $ani={isPageVisible}
              alt="hand1"
              src={hand1L}
              onLoad={onLoadImages}
            />
          </picture>
          <picture>
            <source
              srcSet={hand2S}
              media="(max-width: 520px)"
              type="image/webp"
            />
            <source
              srcSet={hand2M}
              media="(max-width: 1024px)"
              type="image/webp"
            />
            <Hand2
              $ani={isPageVisible}
              alt="hand2"
              src={hand2L}
              onLoad={onLoadImages}
            />
          </picture>
        </AllElements>
      </AnimationContainer>
      <Gradient />
      <TitleContainer $hidden={isPageVisible}>
        <Title>
          "Я хотела, чтобы мои дети понимали: насилие – это ненормально"
        </Title>
        <Subtitle>
          Как Ирода освободилась от 25-летнего абьюза и открыла бизнес своей
          мечты в Узбекистане
        </Subtitle>
      </TitleContainer>
    </IntroContainer>
  )
}
